/* eslint-disable @typescript-eslint/no-magic-numbers */
import Vue from 'vue';
type IHandler = (this: HTMLElement, ev: any) => any;
const on = (function() {
  return function(element: HTMLElement, event: any, handler: IHandler) {
    if (element && event && handler) {
      element.addEventListener(event, handler, false);
    }
  };
})();
type IEl = HTMLElement & {
  tapObj: { [index: string]: any };
  documentHandler: Function;
  bindingFn: Function;
};
function touchstart(e: TouchEvent, el: Partial<IEl>) {
  const touches = e.touches[0];
  const tapObj = el.tapObj!;
  tapObj.pageX = touches.pageX;
  tapObj.pageY = touches.pageY;
  tapObj.clientX = touches.clientX;
  tapObj.clientY = touches.clientY;
  tapObj.time = Number(new Date());
  // e.preventDefault()
}
function touchend(e: TouchEvent, el: Partial<IEl>) {
  const touches = e.changedTouches[0];
  const tapObj = el.tapObj!;
  tapObj.time = Number(new Date()) - tapObj.time;
  tapObj.endTime = '';
  tapObj.distanceX = tapObj.pageX - touches.pageX;
  tapObj.distanceY = tapObj.pageY - touches.pageY;
  const isLongTap =
    tapObj.time > 500 &&
    Math.abs(tapObj.distanceX) < 10 &&
    Math.abs(tapObj.distanceY) < 10;
  if (!isLongTap || tapObj.endTime) return;
  el.documentHandler!();
}

type IDirective = Parameters<typeof Vue.directive>[1];

const directive: NonNullable<IDirective> = {
  bind(el, binding) {
    on(el, 'touchstart', e => {
      touchstart(e, el);
    });
    on(el, 'touchcancel', e => {
      touchend(e, el);
    });
    on(el, 'touchend', e => {
      touchend(e, el);
    });
    (el as Partial<IEl>).tapObj = {};
    (el as Partial<IEl>).bindingFn = binding.value;
    (el as Partial<IEl>).documentHandler = function() {
      (el as Partial<IEl>).bindingFn!();
    };
  },
};

export default directive;
